'use client';

import { useEffect } from 'react';
import Alert from '@molecules/Alert/Alert';
import { IconColorType } from '@atoms/Icon/Icon';
import { trackGlobalMessage } from '@helpers/analyticsHelpers/trackGlobalMessage';
import { setGlobalMessageDisplayState } from '@helpers/localStorageFacade';

type GlobalMessageType = {
  backgroundColor: string;
  container: string;
  fontColor: string;
  hasCloseIcon: string;
  hideInWeb: string;
  message: string;
  name: string;
  synchronizationBlocked: string;
  typeCode: string;
  uid: string;
  uuid: string;
};

interface Props {
  data: GlobalMessageType;
}

const GlobalMessage = ({ data }: Props) => {
  const onClose = () => {
    setGlobalMessageDisplayState(data.uuid);
    trackGlobalMessage('global_notification_closed', data.message);
  };

  useEffect(() => {
    trackGlobalMessage('global_notification_shown', data.message);
  }, [data.message]);

  return data.hideInWeb !== 'true' ? (
    <Alert
      id={data.uid}
      callback={onClose}
      fontColor={data.fontColor}
      backgroundColor={data.backgroundColor}
      buttonColor={data.fontColor as IconColorType}
      hasCloseButton={data.hasCloseIcon === 'true'}
    >
      {data.message}
    </Alert>
  ) : null;
};

export default GlobalMessage;
